/* =============================================================
   rv-reverse.js — Reverse Formula (sections/rv-reverse.liquid).
   Come sul sito che ha mandato Stefano (arcteryx.com/explore/system0):
   1. l'apertura è una frase nel carattere del tema che si accende PAROLA PER PAROLA, poi sparisce;
   2. subito dopo il logo Reverse e il cavallo Martin stanno al centro, ai due lati; al primo scorrimento
      salgono in alto e diventano l'intestazione (il cavallo riporta al sito Martin);
   3. le frasi grandi della presentazione e dell'indice si accendono parola per parola mentre scorri;
   4. i video di sfondo: ogni scena prende il formato che il browser sa leggere (AV1, HEVC, H.264),
      lo carica quando la scena sta per arrivare e lo ferma quando esce.
   Chi ha chiesto meno animazioni (prefers-reduced-motion) vede tutto acceso, senza movimenti.
   ============================================================= */
(function () {
  var root = document.getElementById('rv-top');
  if (!root) return;
  var fermo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- le parole: ogni parola diventa un pezzo che si può accendere ---------- */
  function aParole(el) {
    if (el.getAttribute('data-pronto')) return [];
    var testo = el.textContent.replace(/\s+/g, ' ').trim();
    el.textContent = '';
    var pezzi = [];
    testo.split(' ').forEach(function (p, i) {
      var w = document.createElement('i');
      w.textContent = (i ? ' ' : '') + p;
      el.appendChild(w);
      pezzi.push(w);
    });
    el.setAttribute('data-pronto', '1');
    return pezzi;
  }

  /* ---------- 1. l'apertura ---------- */
  var apertura = root.querySelector('[data-rv-apertura]');
  var marchi = root.querySelector('[data-rv-marchi]');
  var visto = false;
  try { visto = sessionStorage.getItem('rv-apertura') === '1'; } catch (e) {}

  function apri() {
    if (!apertura || apertura.hidden) return;
    apertura.classList.add('is-via');
    try { sessionStorage.setItem('rv-apertura', '1'); } catch (e) {}
    setTimeout(function () { apertura.hidden = true; }, 950);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (marchi) marchi.classList.add('is-on');
  }

  if (apertura && !visto) {
    var tutte = [];
    Array.prototype.slice.call(apertura.querySelectorAll('.rv-apertura__riga')).forEach(function (r) {
      tutte = tutte.concat(aParole(r));
    });
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (fermo) {
      tutte.forEach(function (w) { w.classList.add('is-on'); });
      setTimeout(apri, 1200);
    } else {
      // una parola ogni 105 ms: tutta la frase in poco più di un secondo, il tempo di leggerla
      tutte.forEach(function (w, i) { setTimeout(function () { w.classList.add('is-on'); }, 500 + i * 105); });
      setTimeout(apri, 500 + tutte.length * 105 + 1500);
    }
    ['wheel', 'touchstart', 'keydown', 'click'].forEach(function (e) {
      window.addEventListener(e, apri, { once: true, passive: true });
    });
  } else {
    if (apertura) apertura.hidden = true;
    if (marchi) { marchi.classList.add('is-on'); marchi.classList.add('is-su'); }
  }

  /* ---------- 2. i marchi salgono in alto ---------- */
  var su = visto;
  function guarda() {
    if (!marchi) return;
    var giu = window.scrollY > window.innerHeight * 0.42; // finché guardi la prima schermata i marchi restano al centro
    if (giu !== su) { su = giu; marchi.classList.toggle('is-su', giu); }
  }
  window.addEventListener('scroll', guarda, { passive: true });
  guarda();

  /* ---------- 3. le frasi grandi si accendono mentre scorri ---------- */
  var frasi = Array.prototype.slice.call(root.querySelectorAll('[data-rv-parole]')).map(function (el) {
    return { el: el, parole: aParole(el) };
  });
  function accendi() {
    var h = window.innerHeight;
    frasi.forEach(function (f) {
      var r = f.el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > h) return;
      var p = (h * 0.86 - r.top) / (h * 0.46);
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      var n = Math.round(p * f.parole.length);
      f.parole.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    });
  }
  if (fermo) {
    frasi.forEach(function (f) { f.parole.forEach(function (w) { w.classList.add('is-on'); }); });
  } else {
    window.addEventListener('scroll', accendi, { passive: true });
    window.addEventListener('resize', accendi);
    accendi();
  }

  /* ---------- 4. i video di sfondo ---------- */
  var prova = document.createElement('video');
  var puo = function (t) { return prova.canPlayType(t) === 'probably' || prova.canPlayType(t) === 'maybe'; };
  var forma = 'h264';
  if (puo('video/mp4; codecs="hvc1.1.6.L93.B0"')) forma = 'hevc';
  if (puo('video/mp4; codecs="av01.0.05M.08"')) forma = 'av1';

  var scene = Array.prototype.slice.call(root.querySelectorAll('[data-rv-video]'));
  function video(scena) {
    if (scena.querySelector('video')) return scena.querySelector('video');
    var src = scena.getAttribute('data-' + forma) || scena.getAttribute('data-h264');
    if (!src) return null;
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto';
    v.src = src;
    v.style.opacity = '0';
    v.style.transition = 'opacity .8s ease';
    scena.appendChild(v);
    v.addEventListener('playing', function () { v.style.opacity = '1'; }, { once: true });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    return v;
  }
  if ('IntersectionObserver' in window) {
    var ioV = new IntersectionObserver(function (voci) {
      voci.forEach(function (x) {
        if (x.isIntersecting) {
          var v = video(x.target);
          if (v && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          var w = x.target.querySelector('video');
          if (w && !w.paused) w.pause();
        }
      });
    }, { rootMargin: '150% 0px 150% 0px' });
    scene.forEach(function (s) { ioV.observe(s); });
  } else {
    scene.forEach(video);
  }

  /* ---------- 5. i pezzi che entrano e i numeri dei capitoli ---------- */
  if ('IntersectionObserver' in window && !fermo) {
    var ioS = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { if (v.isIntersecting) { v.target.classList.add('is-on'); ioS.unobserve(v.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    root.querySelectorAll('.rv-su').forEach(function (e) { ioS.observe(e); });
  } else {
    root.querySelectorAll('.rv-su').forEach(function (e) { e.classList.add('is-on'); });
  }

  var primo = root.querySelector('#rv-1');
  if (marchi && primo && 'IntersectionObserver' in window) {
    var ioT = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { marchi.classList.toggle('is-capitoli', v.isIntersecting || v.boundingClientRect.top < 0); });
    }, { rootMargin: '0px 0px -85% 0px' });
    ioT.observe(primo);
  }
  var nav = root.querySelector('[data-rv-nav]');
  if (nav && 'IntersectionObserver' in window) {
    var voci = {};
    Array.prototype.slice.call(nav.querySelectorAll('a')).forEach(function (a) { voci[a.getAttribute('href').slice(1)] = a; });
    var ioC = new IntersectionObserver(function (righe) {
      righe.forEach(function (r) {
        if (!r.isIntersecting || !voci[r.target.id]) return;
        Object.keys(voci).forEach(function (k) { voci[k].classList.toggle('is-on', k === r.target.id); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    root.querySelectorAll('.rv-cap[id]').forEach(function (s) { ioC.observe(s); });
  }
})();
